module.exports = __webpack_public_path__ + "img/Presentation.765d4417.jpeg";